import { useState } from "react";
import { REVIEW_ITEMS, type PetRecord } from "../../../shared/types";
import { api, type SealResult } from "../../api";
import { Modal } from "../Modal";
import { VisitFields, allReviewed, draftToInput, emptyDraft } from "./VisitFields";

const today = () => new Date().toISOString().slice(0, 10);

export function NewVisitModal({ record, onClose, onSaved }: { record: PetRecord; onClose: () => void; onSaved: (s: SealResult & { notes?: { seq: number }[] }) => void }) {
  const [visitDate, setVisitDate] = useState(today());
  const [draft, setDraft] = useState(emptyDraft());
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const left = REVIEW_ITEMS.length - draft.reviewed.length;
  const ready = draft.title.trim() && draft.summary.trim() && allReviewed(draft);

  async function submit() {
    setBusy(true);
    setError(null);
    try {
      onSaved(await api.addVisit(record.pet.id, { ...draftToInput(draft, record), visitDate }));
    } catch (e) {
      setError((e as Error).message);
      setBusy(false);
    }
  }

  return (
    <Modal
      title={`New visit — ${record.pet.displayName}`}
      onClose={onClose}
      width={760}
      footer={
        <>
          <span className="fine" style={{ marginRight: "auto", alignSelf: "center" }}>Saving signs the visit and seals it as block #{record.chain.length}. It cannot be edited later.</span>
          <button className="btn ghost" onClick={onClose}>Cancel</button>
          <button className="btn teal" disabled={busy || !ready} onClick={submit}
            title={left ? "Review every main parameter first" : undefined}>
            {busy ? "Sealing…" : left ? `Review remaining (${left})` : "Sign & seal visit"}
          </button>
        </>
      }
    >
      <div className="field" style={{ maxWidth: 220 }}><label>Visit date</label><input type="date" value={visitDate} max={today()} onChange={(e) => setVisitDate(e.target.value)} /></div>
      <VisitFields draft={draft} setDraft={setDraft} record={record} />
      {error && <div className="err">{error}</div>}
    </Modal>
  );
}
